import "core-js/modules/es7.object.get-own-property-descriptors";
import _defineProperty from "D:/zlwl/portal/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SelectInput from "../../../SelectInput/index";
import AddInput from "../../../AddInput/index";
import networkInfo from "../../../networkInfo/index";
import { updateConfig as _updateConfig, listConfig, getNetworkInfo } from "@/api/configurationlist";
import { cloneDeep, isEqual } from 'lodash';
export default {
  props: ["deviceDid", "deviceSn"],
  data: function data() {
    return {
      protocol: [{
        label: this.$t('lang.ConfigSetting.Staticaddress'),
        value: "static"
      }],
      protocolVlue: "proto",
      //IPv4子网掩码下拉数组
      IPv4protocol: [{
        label: "255.255.255.0",
        value: "255.255.255.0"
      }, {
        label: "255.255.0.0",
        value: "255.255.0.0"
      }, {
        label: "255.0.0.0",
        value: "255.0.0.0"
      }, {
        label: this.$t('lang.ConfigSetting.custom'),
        value: "自定义"
      }],
      IPv4protocolValue: "255.255.255.0",
      //监听到是否修改的值
      WatchData: {
        proto: "",
        ipaddr: "",
        netmask: "",
        macaddr: "",
        dns: "",
        mtu: "",
        metric: ""
      },
      data: {},
      //获取父组件传过来的值
      PropsData: null,
      loading: true,
      //验证
      error: {
        ipaddr: false
      },
      // 网络接口基本信息
      networkInfo: {}
    };
  },
  components: {
    SelectInput: SelectInput,
    AddInput: AddInput,
    networkInfo: networkInfo
  },
  watch: {
    deviceSn: {
      immediate: true,
      handler: function handler(newValue, oldValue) {
        this.getConfig();
      }
    }
  },
  activated: function activated() {
    var _this = this;

    this.fetchNetworkInfo();
    this.timer = setInterval(function () {
      _this.fetchNetworkInfo();
    }, 10000);
  },
  deactivated: function deactivated() {
    clearInterval(this.timer);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    // 获取配置参数
    getConfig: function getConfig() {
      var _this2 = this;

      this.loading = true;
      clearInterval(this.timer);
      listConfig(this.deviceSn, this.deviceDid, [{
        section: "mgt",
        config: "network",
        options: [{
          option: "proto"
        }, {
          option: "ipaddr"
        }, {
          option: "netmask"
        }, {
          option: "dns"
        }, {
          option: "macaddr"
        }, {
          option: "mtu"
        }, {
          option: "metric"
        }]
      }]).then(function (res) {
        _this2.data = res.data.data.mess[0].s_objects[0].options;
        _this2.WatchData = cloneDeep(_this2.data);

        _this2.fetchNetworkInfo();

        _this2.timer = setInterval(function () {
          _this2.fetchNetworkInfo();
        }, 10000);
        _this2.loading = false;
      }).catch(function (err) {
        _this2.$message({
          message: _this2.$t('lang.request.timeout'),
          type: "warning"
        });
      });
    },
    // 获取接口基本信息
    fetchNetworkInfo: function fetchNetworkInfo() {
      var _this3 = this;

      getNetworkInfo(this.deviceDid, this.deviceSn, ['mgt']).then(function (res) {
        _this3.networkInfo = res.data.data.mess.mgt;
      });
    },
    //接收SelectInput的改变传过来的值
    GetSelectValue: function GetSelectValue(props) {
      this.data.netmask = props;
    },
    //接收AddInput的改变传过来的值
    GetAddInput: function GetAddInput(props) {
      this.data.dns = props;
    },
    //提交修改
    updateConfig: function updateConfig() {
      var _this4 = this;

      if (this.error.ipaddr) {
        return;
      }

      if (Object.keys(this.data).length > 0) {
        if (!isEqual(this.WatchData, this.data)) {
          clearInterval(this.timer); //提交修改

          _updateConfig(this.deviceSn, this.deviceDid, [{
            section: "mgt",
            config: "network",
            action: 0,
            index: [0],
            server: "network",
            options: _objectSpread({}, this.data)
          }]).then(function (res) {
            if (res.data.data.mess === 0) {
              _this4.$message({
                showClose: true,
                message: _this4.$t('lang.ConfigSetting.Successfulconfiguration'),
                type: "success"
              });

              _this4.getConfig();
            } else {
              _this4.$message({
                showClose: true,
                message: _this4.$t('lang.ConfigSetting.Configurationerror'),
                type: "warning"
              });

              return;
            }
          }).catch(function (err) {// console.log('请求超时')
            // console.log(err)
          });
        } else {
          this.$message({
            showClose: true,
            message: this.$t('lang.ConfigSetting.Nochangesmade'),
            type: 'warning'
          });
          return;
        }
      }
    },
    //ipv4验证
    ErrorIpaddr: function ErrorIpaddr(props) {
      var test = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
      var retu = false;

      if (!test.test(props)) {
        this.error.ipaddr = true;
        retu = true;
      }

      if (!props) {
        this.error.ipaddr = false;
        retu = false;
      }

      if (!retu) {
        this.error.ipaddr = false;
      }
    }
  }
};